<template>
  <Card class="employee-card">
    <div class="section">
      <div class="title">{{title}}</div>
      <slot name="btn"></slot>
    </div>
    <slot name="content"></slot>
  </Card>
</template>
<script>
export default {
  name: "formInfo",
  components: {},
  props: {},
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ""
    },
  },
  created() {}
};
</script>
<style lang="less" scoped>
.section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 15px;
  font-weight: bold;
  line-height: 15px;
  height: 15px;
  padding-left: 5px;
  border-left: 2px solid #ff7b44;
  margin-bottom: 15px;
}
.employee-card {
  width: 97%;
  // min-height: 600px;
  margin: 0 auto;
}
</style>